// services/exportApi.js
import { baseApi } from "../baseApi";

export const exportApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    exportToCSV: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.react_api.export_doctype_to_csv`,
        method: 'POST',
        body:  data,
        responseHandler: async (response) => {
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `${data.doctype.replace(/\s+/g, "_").toLowerCase()}.csv`;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
          return true;
        },
      }),
    }),
  }),
});

export const { useExportToCSVMutation } = exportApi;
